<template>
  <div class="filter-bar">
    <!-- 条件字段(页面自定义) -->
    <div class="fb-row"><slot /></div>
    <!-- 操作行:搜索/重置 + 额外按钮 -->
    <div v-if="showActions" class="fb-row">
      <Button type="primary" @click="$emit('search')">{{ searchText }}</Button>
      <Button type="error" @click="$emit('reset')">{{ resetText }}</Button>
      <slot name="actions" />
    </div>
    <!-- 绿色日期快捷行 -->
    <div v-if="showShortcuts" class="fb-row">
      <Button v-for="s in shortcuts" :key="s.key" type="success" @click="$emit('shortcut', s.key)">{{ s.label }}</Button>
    </div>
  </div>
</template>

<script>
// 通用筛选栏(收敛各列表页手写的 .table-form/.ff-row 三行结构)
// 页面把条件字段放默认 slot;操作按钮/日期快捷由本组件统一渲染并抛事件。
export default {
  name: 'FilterBar',
  props: {
    showActions: { type: Boolean, default: true },
    showShortcuts: { type: Boolean, default: false },
    searchText: { type: String, default: '搜索' },
    resetText: { type: String, default: '重置' },
    shortcuts: {
      type: Array,
      default: () => [
        { key: 'today', label: '今天' },
        { key: 'yesterday', label: '昨天' },
        { key: 'thisWeek', label: '本周' },
        { key: 'lastWeek', label: '上周' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../styles/tokens.less';
.filter-bar {
  display: flex; flex-direction: column; gap: 10px;
  background: @bg-white; padding: 12px; border-radius: @radius; margin-bottom: 10px;
}
.fb-row { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
// 字段标签(页面可用 .fb-label 给 slot 内 <span> 上色)
.fb-row :deep(.fb-label) { color: @text-sub; font-size: 13px; margin-left: 4px; }
</style>
